import { render, staticRenderFns } from "./KnowledgeCenterListRep.vue?vue&type=template&id=5c15dcf5&"
import script from "./KnowledgeCenterListRep.vue?vue&type=script&lang=js&"
export * from "./KnowledgeCenterListRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports